import {
  attribute,
  autoGeneratedHashKey,
  rangeKey,
  table,
  versionAttribute,
} from '@nova-odm/annotations'

@table('users')
export class SignupWizardUsersModel {
  @autoGeneratedHashKey()
  id: number

  @attribute()
  compamnyIds: Array<number>

  @attribute()
  createdAt: Date

  @attribute()
  updatedAt: Date

  @attribute()
  email: string

  @attribute()
  mobile?: number
  /**
   *  test send push notification
   */
  @attribute()
  firstName: string

  @attribute()
  lastName: string
}